export default __webpack_public_path__ + "static/media/dominos-bread.5845a18d.png";